module.exports = __webpack_public_path__ + "static/Landing_Illustration-05.72126117.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing_Illustration-05.png
// module id = 61
// module chunks = 35783957827783 40787343088564